import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";

import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import { withRouter } from "react-router-dom";
import { Select, MenuItem } from '@material-ui/core'

import Breadcrumb from "../../components/Breadcrumb";
import Heading from "../../components/Heading";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import PayerPayments from "./PayerPayments";
import PayeePayments from "./PayeePayments";
import PaymentDetailModal from "./PaymentDetailModal";
import Loading from "../../components/loadingSpinner/Loading";
import ReportDateFilter from "../../components/reports/ReportDateFilter";
import StaffFilter from "../../components/filters/StaffFilter";
import { ProfileType } from "../../types/enum";

@inject("templateStore", "profileStore", "superLedgerPaymentStore", "reportStore")
@withRouter
@observer
class Payments extends Component {
    constructor(props) {
        super(props);
        this.props.reportStore.resetFilterData();
        this.props.superLedgerPaymentStore.resetAll();
        this.state = {
            tabValue: 0,
            isLoading: false,
            payerLoaded: false,
            payeeLoaded: false,
            showPaymentModal: false,
            selectedPayment: null
        };
    }

    componentDidMount() {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        this.props.reportStore.initialFilter();
        
        if (currentProfile) {
            this.loadPayerPayments();
        }
    }

    loadPayerPayments = () => {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        this.setState({ isLoading: true });
        
        this.props.superLedgerPaymentStore.resetPayerPage();
        this.props.superLedgerPaymentStore.getPaymentsByPayerId(currentProfile.id).then(() => {
            this.setState({
                isLoading: false,
                payerLoaded: true
            });
        });
    }

    loadPayeePayments = () => {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        this.setState({ isLoading: true });
        
        this.props.superLedgerPaymentStore.resetPayeePage();
        this.props.superLedgerPaymentStore.getPaymentsByPayeeId(currentProfile.id).then(() => {
            this.setState({
                isLoading: false,
                payeeLoaded: true
            });
        });
    }

    handleTabChange = (event, tabValue) => {
        this.setState({ tabValue });
        
        if (tabValue === 0 && !this.state.payerLoaded) {
            this.loadPayerPayments();
        } else if (tabValue === 1 && !this.state.payeeLoaded) {
            this.loadPayeePayments();
        }
    };

    reloadPayments = (filterData) => {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        const { tabValue } = this.state;
        
        this.setState({ isLoading: true, payerLoaded: false, payeeLoaded: false });
        
        if (filterData) {
            this.props.reportStore.setStartDate(filterData.startDate);
            this.props.reportStore.setEndDate(filterData.endDate);
        }
        
        this.props.superLedgerPaymentStore.resetPayerPage();
        this.props.superLedgerPaymentStore.resetPayeePage();
        
        if (tabValue === 0) {
            this.props.superLedgerPaymentStore.getPaymentsByPayerId(currentProfile.id).then(() => {
                this.setState({
                    isLoading: false,
                    payerLoaded: true
                });
            });
        } else {
            this.props.superLedgerPaymentStore.getPaymentsByPayeeId(currentProfile.id).then(() => {
                this.setState({
                    isLoading: false,
                    payeeLoaded: true
                });
            });
        }
    }

    handleStatusChange = (event) => {
        this.props.superLedgerPaymentStore.setFilterAttr('status', event.target.value || undefined);
        this.reloadPayments();
    }

    handleViewPayment = (payment) => {
        this.setState({
            showPaymentModal: true,
            selectedPayment: payment
        });
    };

    handleClosePaymentModal = () => {
        this.setState({
            showPaymentModal: false,
            selectedPayment: null
        });
    };

    handlePaymentDeleted = () => {
        this.reloadPayments();
    };

    handlePaymentUpdated = () => {
        this.reloadPayments();
    };

    render() {
        const { tabValue, isLoading, showPaymentModal, selectedPayment } = this.state;
        const { currentProfile } = this.props.profileStore;
        const { filter } = this.props.superLedgerPaymentStore;

        const breadcrumb = [];
        if (currentProfile && currentProfile.type) {
            breadcrumb.push(
                { name: "Dashboard", link: "/" + this.props.templateStore.getTypeString(currentProfile.type) },
                { name: "Payments" }
            );
        }

        return (
            <Fragment>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Breadcrumb links={breadcrumb} />
                    {currentProfile ? (
                        <Heading title="Payments">
                            <Grid container spacing={8} justify="flex-end" alignItems="center">
                                <Grid xs = { 12 } lg = {3} item className="filterHalf">
                                    <Select
                                        value={filter.status || ""}
                                        onChange={this.handleStatusChange}
                                        displayEmpty
                                        className="dark-select"
                                        classes={{
                                            root: "text-white",
                                            icon: "text-white"
                                        }}
                                    >
                                        <MenuItem value="">All Statuses</MenuItem>
                                        <MenuItem value="pending">Pending</MenuItem>
                                        <MenuItem value="submitted">Submitted</MenuItem>
                                        <MenuItem value="settled">Settled</MenuItem>
                                        <MenuItem value="paid">Paid</MenuItem>
                                        <MenuItem value="partiallypaid">Partially Paid</MenuItem>
                                        <MenuItem value="failed">Failed</MenuItem>
                                    </Select>
                                </Grid>
                                <Grid item>
                                    {currentProfile.type === ProfileType.Staff.ordinal ? (
                                        <StaffFilter postChangeEvent={this.reloadPayments} hideAllTime={true} />
                                    ) : (
                                        <ReportDateFilter isLoading={isLoading} postChangeEvent={this.reloadPayments} hideAllTime={true} />
                                    )}
                                </Grid>
                            </Grid>
                        </Heading>
                    ) : null}

                    <Paper style={{ position: "relative" }}>
                        <AppBar position="static" elevation={2}>
                            <Tabs
                                value={tabValue}
                                onChange={this.handleTabChange}
                                indicatorColor="primary"
                                textColor="secondary"
                                scrollable
                                scrollButtons="off"
                                classes={{
                                    root: "tabs-root",
                                    indicator: "tabs-indicator"
                                }}
                            >
                                <Tab label="Payments I Made" classes={{ selected: "tab-selected" }} />
                                <Tab label="Payments Received" classes={{ selected: "tab-selected" }} />
                            </Tabs>
                        </AppBar>

                        <Paper className="org-paper-form" style={{ borderRadius: "0px 0px 2px 2px", position: "relative" }}>
                            <Loading showed={isLoading} />
                            
                            {tabValue === 0 && (
                                <PayerPayments 
                                    profileId={currentProfile?.id}
                                    onLoadMore={() => {
                                        this.props.superLedgerPaymentStore.loadMorePayerPayments(currentProfile?.id);
                                    }}
                                    onViewPayment={this.handleViewPayment}
                                />
                            )}
                            {tabValue === 1 && (
                                <PayeePayments 
                                    profileId={currentProfile?.id}
                                    onLoadMore={() => {
                                        this.props.superLedgerPaymentStore.loadMorePayeePayments(currentProfile?.id);
                                    }}
                                    onViewPayment={this.handleViewPayment}
                                />
                            )}
                        </Paper>
                    </Paper>

                    <PaymentDetailModal
                        open={showPaymentModal}
                        payment={selectedPayment}
                        onClose={this.handleClosePaymentModal}
                        onDeleteSuccess={this.handlePaymentDeleted}
                        onPaymentUpdated={this.handlePaymentUpdated}
                        viewMode={tabValue === 0 ? 'payer' : 'payee'}
                    />
                </MainContainer>
            </Fragment>
        );
    }
}

export default Payments;
